import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import messages from 'containers/TransactionManagerTimeLine/Transaction/messages';
import DecisionDialog from 'components/DecisionDialog/index';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { TRANSACTION_STATUS } from 'containers/TransactionManagerTimeLine/constants';
import { TransactionType } from 'typings/globalTypes';

export interface RejectTransactionDialogProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  requestRejectTransaction: Function;
  transactionInfo: TransactionType;
}

export const RejectTransactionDialog: React.FC<RejectTransactionDialogProps> = (
  props,
): JSX.Element => {
  const [reason, setReason] = React.useState(null);
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };

  const handleValidate = () => {
    props.requestRejectTransaction(
      {
        rollBackRejection:
          get(props.transactionInfo, 'transactionStatus.title', null) ===
          TRANSACTION_STATUS.UNSUCCESSFUL_TRANSACTION,
        rejectionReason: reason,
        decidedBy: currentUserStorage?.get().username,
        decidedAt: new Date(),
        transactionId: get(props.transactionInfo, 'id'),
        claimId: get(props.transactionInfo, 'claimId'),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallback,
    );
  };
  const successCallback = () => {
    toast.success(translate(messages.validationToastSuccess, props));
    props.handleClose();
  };

  return (
    <DecisionDialog
      open={props.open}
      onClose={props.handleClose}
      validateDialog={handleValidate}
      title={
        get(props.transactionInfo, 'transactionStatus.title', null) !=
        TRANSACTION_STATUS.UNSUCCESSFUL_TRANSACTION
          ? translate({ ...messages.rejectTransaction }, props)
          : translate({ ...messages.cancelRejectTransaction }, props)
      }
      content={
        <StyledDiv>
          {translate(messages.courtManagerConfirmationDialogContent, props)}
          {get(props.transactionInfo, 'transactionStatus.title', null) !=
            TRANSACTION_STATUS.UNSUCCESSFUL_TRANSACTION && (
            <TextField
              onChange={handleChangeReason}
              name={'reason'}
              value={reason}
              label={translate({ ...messages.reason }, props)}
              className="input"
              multiline
              fullWidth
            />
          )}
        </StyledDiv>
      }
      disabled={
        get(props.transactionInfo, 'transactionStatus.title', null) !=
          TRANSACTION_STATUS.UNSUCCESSFUL_TRANSACTION && !reason
      }
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

export default injectIntl(RejectTransactionDialog);
